import { createContext, useContext } from 'react';

interface SidebarContextValue {
  sidebarOpened: boolean;
  isActive: (path: string, href: string) => boolean;
  onMenuItemClick: (pageTitle: string) => void;
  setSubmenusVisibleItemsCount?: (count: number) => void;
}

export const SidebarContext = createContext<SidebarContextValue | null>(null);

export const useSidebarContext = (): SidebarContextValue => {
  const ctx = useContext(SidebarContext);

  if (!ctx) {
    throw new Error('useSidebarContext must be used within SidebarContext');
  }

  return ctx;
};
